import './status.scss';
import { h } from 'preact';

export default function Status({ id, isSelected, label, value, handleChange }) {
	function onChange() {
		handleChange(value);
	}

	return (
		<div class={'status-container status-' + value + (isSelected ? ' is-selected' : '')} aria-checked={isSelected}>
			<input type="checkbox" id={id} onChange={onChange} checked={isSelected} />
			<label class="status-label" for={id}>{label}</label>
		</div>
	);
}
